import { Collection } from 'modules/core/lib/mobx-rest'

import Condition from 'modules/reports/store/models/Condition'

class Conditions extends Collection<Condition> {
  get cacheKey(): string {
    return 'conditions'
  }

  model() {
    return Condition
  }
}

const singleton: Conditions = new Conditions()

export default singleton
